import type { AppInfoMessage } from 'BrokerTsLib/src/dtos'
import {
  useGetAppInfoMessage,
  useSaveAppInfoMessage,
} from 'BrokerTsLib/src/hooks/useAppInfoMessage'
import { useNavigate, useParams } from 'react-router-dom'

import { AppInfoForm } from '@/components/AppInfo/AppInfoForm'
import {
  DashboardHeader,
  DashboardHeaderBackButton,
} from '@/containers/dashboard/DashboardHeader'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { useCustomToast } from 'BrokerTsLib/src/hooks/useCustomToast'

export const AppInfoEditPage = () => {
  const navigate = useNavigate()
  const { appInfoId } = useParams()
  const { data } = useGetAppInfoMessage(appInfoId!)

  const { mutateAsync: saveAppInfoAsync } = useSaveAppInfoMessage()

  const { successToast, errorToast } = useCustomToast()

  const onSubmit = (value: AppInfoMessage) =>
    saveAppInfoAsync(value)
      .then(successToast('Aktualita byla úspěšně uložena'))
      .catch(errorToast('Chyba při ukládání aktuality'))

  return (
    <PageWrapper
      header={
        <DashboardHeader title="Upravit aktualitu">
          <DashboardHeaderBackButton onClick={() => navigate('../admin')}>
            Zpět na správu aktualit
          </DashboardHeaderBackButton>
        </DashboardHeader>
      }
      mainProps={{
        sx: {
          pt: { base: 0, sm: 8 },
          gap: 4,
          display: 'grid',
          w: { base: '100%', sm: 'lg', lg: '4xl' },
          margin: '0 auto',
        },
      }}
    >
      {data && <AppInfoForm appInfo={data} onSubmit={onSubmit} />}
    </PageWrapper>
  )
}
